import { CSSObject } from '@emotion/react';
/**
 * NOTE: ライブラリの違いで入力フォームのデザインに差分があるため、chakra-uiに寄せる形でスタイルを調整
 * 対応PR：https://github.com/tacoms-inc-dev/camel-dashboard-react-frontend/pull/842/files
 * ***/
export const reactSelectStyle = {
  control: (baseStyles: CSSObject): CSSObject => ({
    ...baseStyles,
    borderColor: 'inherit',
    '&:hover': {
      borderColor: '#CBD5E0',
    },
    'border-radius': '0.375rem',
  }),
  indicatorSeparator: (baseStyles: CSSObject): CSSObject => ({
    ...baseStyles,
    backgroundColor: 'rgb(226, 232, 240)',
  }),
};
